import { withQuery } from "./query";
import { Get } from "./request";

/** The people a view can be granted to - anyone who can sign in to the portal. */
export function GetPortalUsers(dispatch) {
  return Get(dispatch, "GetPortalUsers");
}

export function GetInitialState(dispatch) {
  return Get(dispatch, "GetInitialState");
}

export function GetReport(dispatch, workspaceId, reportId) {
  let url = withQuery("GetReport", { workspaceId, reportId });
  return Get(dispatch, url);
}
